import { render, staticRenderFns } from "./RouterLocale.vue?vue&type=template&id=38bca072&"
import script from "./RouterLocale.vue?vue&type=script&lang=js&"
export * from "./RouterLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports